module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/26 vrchni sal.jpg";